import React from "react"

import {
  Car,
  CardInSuitcase,
  Cashback,
  FireExtinguisher,
  InstallmentPlan,
  MoneyTransfer,
  ThreeCards,
  Roubles,
  Redlabel,
  RedCar,
  Months,
  FivePercentCoins,
  Defender,
  Cashback100,
} from "./images"

import type { BenefitsItem } from "./types"

const hintClassNames = {
  // 10 МЕСЯЦ

  c1: {
    xs: {
      left: 20,
      top: -30,
    },
    sm: {
      left: 22,
      top: -40,
    },
    md: {
      top: -8,
      left: -16,
    },

    lg: {
      left: 24,
      top: -45,
    },
  },
  // ДО 12%

  c2: {
    xs: {
      left: 20,
      top: -30,
    },
    sm: {
      left: 20,
      top: -30,
    },
    md: {
      left: 22,
      top: -43,
    },

    lg: {
      left: 24,
      top: -45,
    },
  },

  c3: {
    xs: {
      left: 20,
      top: -30,
    },
    sm: {
      top: -5,
      left: -50,
    },
    md: {
      top: -10,
      left: -75,
    },

    lg: {
      left: 24,
      top: -45,
    },
  },
  // ПЕРЕВОДЫ
  c4: {
    xs: {
      left: 20,
      top: -30,
    },
    sm: {
      left: 22,
      top: -40,
    },
    md: {
      left: 22,
      top: -43,
    },

    lg: {
      left: 24,
      top: -45,
    },
  },
}

const itemsMedia = [
  {
    Img: InstallmentPlan,
    alt: "ten months",
    title: (
      <>
        Увеличенная рассрочка*
        <b>
          <br /> от 10 месяцев
        </b>
        <br className="d-tab-only-none" /> у всех партнеров
      </>
    ),
    tooltipHint:
      "Увеличенная рассрочка* у всех партнеров. Совершайте покупки у любых партнеров Халвы со сроком рассрочки* от 10 месяцев и больше.",
    hintClassName: hintClassNames.c1,
  },
  {
    Img: Defender,
    alt: "Purchase protection",
    title: (
      <>
        <b>Защита</b>
        <br />
        покупок
      </>
    ),
    tooltipHint: (
      <>Автоматическая защита всех важных покупок и юридическая помощь по правам покупателей 24/7</>
    ),
    hintClassName: hintClassNames.c2,
  },
  {
    Img: Cashback,
    alt: "cashback",
    title: (
      <>
        Кешбэк <br /> <b>до 10% </b>
      </>
    ),
    tooltipHint:
      "При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси «Яндекс Go».",
    hintClassName: hintClassNames.c3,
  },
  {
    Img: FivePercentCoins,
    alt: "five percent coins",
    title: (
      <>
        <b>+5%</b> <br /> к ставке вклада
      </>
    ),
    tooltipHint: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
        от&nbsp;20&nbsp;000 ₽. +2% годовых добавляется к&nbsp;ставке вклада, открытого
        на&nbsp;24&nbsp;мес., +5% для вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим срокам +1%).
      </>
    ),
    hintClassName: hintClassNames.c4,
  },
]

const itemsSticker = [
  {
    Img: InstallmentPlan,
    alt: "ten months",
    title: (
      <>
        Увеличенная рассрочка*
        <b>
          <br /> от 10 месяцев
        </b>
        <br className="d-tab-only-none" /> у всех партнеров
      </>
    ),
    tooltipHint:
      "Увеличенная рассрочка* у всех партнеров. Совершайте покупки у любых партнеров Халвы со сроком рассрочки* от 10 месяцев и больше.",
    hintClassName: hintClassNames.c1,
  },
  {
    Img: Defender,
    alt: "Purchase protection",
    title: (
      <>
        <b>Защита</b>
        <br />
        покупок
      </>
    ),
    tooltipHint: (
      <>Автоматическая защита всех важных покупок и юридическая помощь по правам покупателей 24/7</>
    ),
    hintClassName: hintClassNames.c2,
  },
  {
    Img: Cashback,
    alt: "cashback",
    title: (
      <>
        Кешбэк <br /> <b>до 10% </b>
      </>
    ),
    tooltipHint:
      "При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси «Яндекс Go».",
    hintClassName: hintClassNames.c3,
  },
  {
    Img: FivePercentCoins,
    alt: "five percent coins",
    title: (
      <>
        <b>До +5%</b> <br /> к ставке вклада
      </>
    ),
    tooltipHint: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
        от&nbsp;20&nbsp;000 ₽. +2% годовых добавляется к&nbsp;ставке вклада, открытого
        на&nbsp;24&nbsp;мес., +5% для вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим срокам +1%).
      </>
    ),
    hintClassName: hintClassNames.c4,
  },
]

const backToSchoolMedia = [
  {
    Img: InstallmentPlan,
    alt: "ten months",
    title: (
      <>
        Увеличенная рассрочка* <b>от&nbsp;10 месяцев</b> у всех партнеров
      </>
    ),
    tooltipHint:
      "Увеличенная рассрочка* у всех партнеров. Совершайте покупки у любых партнеров Халвы со сроком рассрочки* от\u00A010 месяцев и больше.",
    hintClassName: hintClassNames.c1,
  },
  {
    Img: Defender,
    alt: "Purchase protection",
    title: (
      <>
        <b>Защита</b> покупок
      </>
    ),
    tooltipHint: (
      <>Автоматическая защита всех важных покупок и юридическая помощь по правам покупателей 24/7</>
    ),
    hintClassName: hintClassNames.c2,
  },
  {
    Img: Cashback100,
    alt: "cashback",
    title: (
      <>
        Кешбэк <b>до 100% </b>
      </>
    ),
    tooltipHint:
      "При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси «Яндекс Go».",
    hintClassName: hintClassNames.c3,
  },
  {
    Img: FivePercentCoins,
    alt: "five percent coins",
    title: (
      <>
        <b>+5%</b> к ставке вклада
      </>
    ),
    tooltipHint: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
        от&nbsp;20&nbsp;000 ₽. +2% годовых добавляется к&nbsp;ставке вклада, открытого
        на&nbsp;24&nbsp;мес., +5% для вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим срокам +1%).
      </>
    ),
    hintClassName: hintClassNames.c4,
  },
]

const refinItems = [
  {
    Img: ThreeCards,
    alt: "three cards",
    title: (
      <>
        Рефинансирование кредитных карт
        <br />
        <b>любых банков</b>
      </>
    ),
  },
  {
    Img: FireExtinguisher,
    alt: "fire extinguisher",
    title: (
      <>
        <b>Просто и быстро</b>
        <br />
        погасим задолженности за&nbsp;вас
      </>
    ),
  },
  {
    Img: CardInSuitcase,
    alt: "card in suitcase",
    title: (
      <>
        Возможность <b>досрочного погашения</b> без&nbsp;комиссий
      </>
    ),
  },
  {
    Img: Car,
    alt: "car",
    title: (
      <>
        <b>Дистанционное оформление</b>
        <br />и бесплатная доставка Халвы
      </>
    ),
  },
]

const refinSeo = [
  {
    Img: ThreeCards,
    alt: "three cards",
    title: (
      <>
        Рефинансирование кредитных карт
        <br />
        <b>любых банков</b>
      </>
    ),
  },
  {
    Img: FireExtinguisher,
    alt: "fire extinguisher",
    title: (
      <>
        <b>Просто и быстро</b>
        <br />
        поможем с&nbsp;рефинансированием задолженности
      </>
    ),
  },
  {
    Img: CardInSuitcase,
    alt: "card in suitcase",
    title: (
      <>
        Возможность <b>досрочного погашения</b> без&nbsp;комиссий
      </>
    ),
  },
  {
    Img: Car,
    alt: "car",
    title: (
      <>
        <b>Дистанционное оформление</b>
        <br />и бесплатная доставка Халвы
      </>
    ),
  },
]

const inviteFriendItems = [
  {
    Img: InstallmentPlan,
    alt: "ten months",
    title: (
      <>
        Увеличенная рассрочка*
        <b>
          <br /> от 10 месяцев
        </b>
        <br /> у всех партнеров
      </>
    ),
    tooltipHint:
      "Увеличенная рассрочка* у всех партнеров. Совершайте покупки у любых партнеров Халвы со сроком рассрочки* от 10 месяцев и больше.",
    hintClassName: hintClassNames.c1,
  },
  {
    Img: Defender,
    alt: "Purchase protection",
    title: (
      <>
        <b>Защита</b>
        <br />
        покупок
      </>
    ),
    tooltipHint: (
      <>Автоматическая защита всех важных покупок и юридическая помощь по правам покупателей 24/7</>
    ),
    hintClassName: hintClassNames.c2,
  },
  {
    Img: Cashback,
    alt: "cashback",
    title: (
      <>
        Кешбэк <br /> <b>до 10% </b>
      </>
    ),
    tooltipHint:
      "При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси «Яндекс Go».",
    hintClassName: hintClassNames.c3,
  },
  {
    Img: MoneyTransfer,
    alt: "money transfer",
    title: (
      <>
        <b>Бесплатное</b> <br /> обслуживание
      </>
    ),
    tooltipHint: "0 руб. за выпуск, перевыпуск и использование карты.",
    hintClassName: hintClassNames.c4,
  },
]

const btsAuto = [
  {
    Img: RedCar,
    alt: "car",
    title: (
      <>
        Главный приз – <br /> <b>Автомобиль</b>
      </>
    ),
  },
  {
    Img: Months,
    alt: "36 months",
    title: (
      <>
        Рассрочка* <br /> <b>до 36 месяцев</b>
      </>
    ),
  },
  {
    Img: Roubles,
    alt: "5000 roubles",
    title: (
      <>
        <b>5 000 баллов</b> <br /> кешбэка
      </>
    ),
  },
  {
    Img: Redlabel,
    alt: "halva label",
    title: (
      <>
        <b>Бонусы&nbsp;от&nbsp;Халвы</b> <br /> и партнеров
      </>
    ),
  },
]

const itemsHalvaMedia = [
  {
    Img: InstallmentPlan,
    alt: "ten months",
    title: (
      <>
        Увеличенная рассрочка*
        <b>
          <br /> от 10 месяцев
        </b>
        <br className="d-tab-only-none" /> у всех партнеров
      </>
    ),
    tooltipHint:
      "Увеличенная рассрочка* у всех партнеров. Совершайте покупки у любых партнеров Халвы со сроком рассрочки* от 10 месяцев и больше.",
    hintClassName: hintClassNames.c1,
  },
  {
    Img: Defender,
    alt: "Purchase protection",
    title: (
      <>
        <b>Зелёная цена* на Ozon</b>
        <br />
        скидка до 30% <br className="d-none d-sm-block" />
        при оплате <br className="d-none d-sm-block" />
        любыми картами <br className="d-none d-sm-block" />
        Совкомбанка
      </>
    ),
  },
  {
    Img: Cashback,
    alt: "cashback",
    title: (
      <>
        Кешбэк <br /> <b>до 10% </b>
      </>
    ),
    tooltipHint:
      "При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси «Яндекс Go».",
    hintClassName: hintClassNames.c3,
  },
  {
    Img: FivePercentCoins,
    alt: "five percent coins",
    title: (
      <>
        <b>+5%</b> <br /> к ставке вклада
      </>
    ),
    tooltipHint: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
        от&nbsp;20&nbsp;000 ₽. +2% годовых добавляется к&nbsp;ставке вклада, открытого
        на&nbsp;24&nbsp;мес., +5% для вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим срокам +1%).
      </>
    ),
    hintClassName: hintClassNames.c4,
  },
]

export const items: Record<
  | "refin"
  | "inviteFriendItems"
  | "btsAuto"
  | "itemsMedia"
  | "backToSchoolMedia"
  | "sticker"
  | "halvaMedia"
  | "refinSeo",
  BenefitsItem[]
> = {
  refin: refinItems,
  refinSeo,
  inviteFriendItems,
  btsAuto,
  itemsMedia,
  backToSchoolMedia,
  sticker: itemsSticker,
  halvaMedia: itemsHalvaMedia,
}
